<template>
  <div :class="styled ? 'vimeo-player' : ''">
    <iframe
      :src="videoSrc"
      :width="width ? width : 640"
      :height="height ? height : 360"
      frameborder="0"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    videoId: String,
    width: Number,
    height: Boolean,
    styled: Array,
    muted: {
      type: Number,
      default: 1,
    },
    loop: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    videoSrc() {
      return `https://player.vimeo.com/video/${this.videoId}?autoplay=1&loop=${this.loop}&muted=${this.muted}&autopause=0`;
    },
  },
};
</script>

<style lang="scss">
.vimeo-player {
  //width: 212px;
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;
  background: #000000;
}
.vimeo-player iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
